import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { PageWithFixedHeaderAndFooterContent, PatientConsentParent } from "./PatientConsentManagerShared.styles";
import { useViewModel } from "./useViewModel";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import { PatientConsentVerifyPhoneViewModel } from "./PatientConsentVerifyPhoneViewModel";
import { VerifyOTPView } from "./VerifyOTPView";
import { ContentContainer } from "./HXMobilePage.styles";
export const PatientConsentVerifyPhoneView = observer((props) => {
    const model = useViewModel(PatientConsentVerifyPhoneViewModel, props.container);
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(ContentContainer, { children: _jsx(VerifyOTPView, { model: model, animate: false }) }) }) }) }));
});
addDisplayName(PatientConsentVerifyPhoneView, "PatientConsentVerifyPhoneView");
